const getFileExtension = (filename: string): string => {
  const dotIndex = filename.lastIndexOf('.')
  return dotIndex > 0 && dotIndex < filename.length - 1
    ? filename.slice(dotIndex + 1)
    : ''
}

export interface DownloadableDocument {
  name?: string
  filename?: string
  type?: string
}

export const getDocumentDownloadName = (
  document: DownloadableDocument
): string => {
  const filename = document.filename?.trim() ?? ''
  const name = document.name?.trim() || filename
  const base = name.replace(/[\\/]/g, '-')

  const type = document.type?.trim() ?? ''
  const typeIsExtension =
    /^[a-z0-9]{1,7}$/i.test(type) &&
    type !== 'folder' &&
    type !== 'file' &&
    type.toLowerCase() !== filename.toLowerCase()
  const extension = typeIsExtension ? type : getFileExtension(filename)

  if (!extension) return base
  if (base.toLowerCase().endsWith(`.${extension.toLowerCase()}`)) return base
  return `${base.replace(/\.+$/, '')}.${extension}`
}
